import { render, staticRenderFns } from "./FormStep2.vue?vue&type=template&id=5b13ccf2&scoped=true"
import script from "./FormStep2.vue?vue&type=script&lang=js"
export * from "./FormStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b13ccf2",
  null
  
)

export default component.exports